module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-dictionary-definitions/wbs-dictionary-definitions.component.css
// module id = ./src/app/wbs-dictionary-definitions/wbs-dictionary-definitions.component.css
// module chunks = main